<main>

    <section class="heroHeader pb-md-5">
        <div class="customContainer container-fluid heroContainer">
            <img src="./assets/img/hero/extended2.jpg" alt="ALPHERA Top Up Cover" class="img-fluid">
            <div class="container">
                <div class="containerWrapper position-relative">
                    <div class="heroCopy">
                        <h1>ALPHERA Extended Service Plan</h1>
                        <p>Our Extended Service Plan offers comprehensive coverage tailored to your needs, ensuring peace of mind on every journey. </p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="introSec bgPattern">
        <div class="container">
            <div class="containerWrapper">
                <div class="breadCrumb">
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li><a routerLink="/insurance">Insurance</a></li>
                        <li><a routerLink="/insurance/top-up-cover">ALPHERA Extended Service Plan</a></li>
                    </ul>
                </div>
                <!-- <h3>Protect yourself from vehicle finance settlement shortfalls</h3>
                <p>Ensure nothing interrupts your journey with insurance engineered to protect you from vehicle finance settlement shortfalls. If your vehicle is stolen or written off, we’ll settle the difference between your comprehensive insurance pay-out and the amount owing on your credit agreement.</p> -->
            </div>
        </div>
    </section>

    <section class="pTB">
        <div class="container">
            <div class="containerWrapper">
                <div class="row justify-content-between align-items-center teaserHorizontal">
                    <div class="col-md-5 order-md-1">
                        <img src="assets/img/teasers/extended/1.jpg" alt="Extended Cover" class="img-fluid">
                    </div>
                    <div class="col-md-7">
                        <div class="teaserCopy pE" data-tracking-regionid="extended cover¦2¦¦anchors¦1¦extended cover">
                            <h3>Why Choose Our Extended Service Plan?</h3>.
                            
                                <ul>
                                    <li>
                                        Comprehensive Coverage: Protect against costly repairs with coverage that includes mechanical breakdowns, parts replacements, and more.
                                    </li>
                                    <li>
                                        Flexible Terms: Choose a plan that fits your lifestyle and budget, with options for various coverage periods and mileage limits.
                                    </li>
                                    <li>
                                        Expert Service: Access our network of certified technicians who provide top-notch service and genuine parts for your vehicle.
                                    </li>
                                    <li>
                                        Budget-Friendly: Manage your vehicle expenses with predictable costs and avoid unexpected repair bills.
                                    </li>
                                </ul>
                            
                            <a href="javascript:void(0);" (click)="goToProduct('Comprehensive Cover')" class="button button-g-blue mb-3" data-tracking-linkid="link¦4¦complete protection - request quote¦internal click">Request Quote</a>
                            
                            <a href="./assets/files/736894_ALPHERA_Extended_Service_Plan_Sales_Guide_FF.pdf" class="button button-ghost" target="_blank" data-tracking-linkid="link¦5¦complete protection - download brochure¦internal click">Download Brochure</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="pTB teasersSec">
        <div class="container">
            <div class="containerWrapper">
                <h3>Benefits of Our Extended Service Plan</h3>
                <!--
                <p>
                    Prolong your peace of mind with Tyre & Extended Warranty Boost from ALPHERA Insurance. You have access to a selection of cover options that shield your vehicle and tyres from unexpected expenses once your Manufacturer Warranty has expired. Just choose the package that suits you based on the age and mileage of your vehicle. 
                </p>
            -->
                <br><br>
                <div class="row">
                    <div class="col-md-6 col-lg-4">
                        <div class="teaserItem">
                            <div class="teaserImg"><img src="./assets/img/teasers/extended/T1.jpg" alt="ALPHERA Top-Up Cover"
                                    class="img-fluid"></div>
                            <div class="teaserDescription">
                                <h3>Peace of Mind</h3>
                                <p> Enjoy worry-free driving knowing your vehicle is protected.
                                     </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="teaserItem">
                            <div class="teaserImg"><img src="./assets/img/teasers/extended/T2.jpg" alt="ALPHERA Top-Up Cover"
                                    class="img-fluid"></div>
                            <div class="teaserDescription">
                                <h3>Enhanced Resale Value</h3>
                                <p>Increase your car’s appeal to potential buyers with transferable coverage.
                                     </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="teaserItem">
                            <div class="teaserImg"><img src="./assets/img/teasers/extended/T3.jpg" alt="ALPHERA Top-Up Cover"
                                    class="img-fluid"></div>
                            <div class="teaserDescription">
                                <h3>24/7 Support</h3>
                                <p> Get assistance anytime with our dedicated customer service team.
                                     </p>
                            </div>
                        </div>
                    </div>
                </div>
                
                
            </div>
        </div>
    </section>

    <section class="pTB">
        <div class="container">
            <div class="containerWrapper">
                <div class="row justify-content-between align-items-center teaserHorizontal">
                    <div class="col-md-5 order-md-1">
                        <img src="./assets/img/teasers/extended/2.jpg" alt="Complete Protection" class="img-fluid">
                    </div>
                    <div class="col-md-7">
                        <div class="teaserCopy pE" data-tracking-regionid="comprehensive cover¦2¦¦anchors¦1¦complete protection">
                            <h3>How It Works</h3>.
                            
                                <ol>
                                    <li>
                                        Select Your Plan: Choose from a range of options tailored to your vehicle and driving needs.
                                    </li>
                                    <li>
                                        Enjoy Coverage: Drive confidently with protection against unforeseen repairs and maintenance.
                                    </li>
                                    <li>
                                        Stay Informed: Receive regular updates and reminders to keep your vehicle in top condition.
                                    </li>
                                </ol>
                            <a href="javascript:void(0);" class="button button-g-blue mb-3" data-tracking-linkid="link¦4¦complete protection - request quote¦internal click">Request Quote</a>
                            <a href="./assets/files/736894_ALPHERA_Extended_Service_Plan_Sales_Guide_FF.pdf" class="button button-ghost" target="_blank" data-tracking-linkid="link¦5¦complete protection - download brochure¦internal click">Download Brochure</a>
                        </div>
                        
                    </div>
                    
                </div>
                <br><br><br>
                ALPHERA Financial Services is a Division of BMW Financial Services (South Africa) (Pty) Ltd, an Authorised Financial Services Provider (FSP 4623) and Registered Credit Provider (NCRCP2341).
            </div>
        </div>
    </section>
</main>